const sessionKey = "accesed";
const sessionValue = true;

if (!sessionStorage.getItem(sessionKey)) {
    document.getElementById("popup").style.display = "block";
    document.querySelector(".section_popup button").addEventListener("click", () => {
        sessionStorage.setItem(sessionKey, sessionValue);
    });
}
$(function () {
    $('.section_popup button').on('click', () => {
        $('.section_popup').fadeOut(300);
    });
});